import { isUndefined } from './isUndefined.js';

export function isEmpty(value) {
  return isUndefined(value) || value === '' || value === null || value !== value;
}
